import {
  Directive,
  HostBinding,
  HostListener,
  ElementRef,
  Input,
  Output,
  EventEmitter
} from '@angular/core';

@Directive({
  selector: '[appBanksSelector]'
})
export class BanksSelectorDirective {
  @Input() readonly: boolean;
  // appBanksSelector: string;
  @HostBinding('class.open') isOpen = false;
  @Output() isOpenChange = new EventEmitter();
  // In order for the bank selector to be opened or closed depends on  whether the class open is on the selector
  @HostListener('document:click', ['$event']) toggleOpen(event: Event) {
    const className = (event.target as Element).className;
    // if (!this.readonly) {
    switch (className) {
      case 'drop-down-checkbox-label': // if the selector is clicked on any of the case
      case 'drop-down-checkbox-label disabled': // if the selector is clicked on any of the case

      case 'drop-down-checkbox': // don't change the open status of the selector
      case 'drop-down-option-container':
      case 'drop-down-inner-container':
      case 'drop-down-container':
      case 'drop-down-option-container ng-star-inserted':
        break;
      default:
        // if the selector is clicked on then do the opposite of what is happening to the selector currently
        // e.g. if open is on the class remove else add it.

        // if anywhere else is clicked on the page then the selector should always be closed

        this.isOpen = this.elemRef.nativeElement.contains(event.target)
          ? !this.isOpen
          : false;
        this.isOpenChange.emit(this.isOpen);
        break;
    }
  }
  constructor(private elemRef: ElementRef) {}
}
